import { API } from 'aws-amplify';

export async function putKhanStatus(input: {
  student_id: string;
}): Promise<{ affectedRows: number }> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = `api/competitions/onboarding/khan/status`;
    const myInit = {
      headers: {},
      body: input,
    };
    return await API.put(apiName, path, myInit);
  } catch (error) {
    console.error('Error updating khan status:', error);
    throw error;
  }
}
